import { motion } from "framer-motion";

const gold = { stroke: "#C9A84C", strokeWidth: 1.5, fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };

const ScissorsIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><circle cx="6" cy="6" r="3" {...gold} /><circle cx="6" cy="18" r="3" {...gold} /><line x1="20" y1="4" x2="8.12" y2="15.88" {...gold} /><line x1="14.47" y1="14.48" x2="20" y2="20" {...gold} /><line x1="8.12" y1="8.12" x2="12" y2="12" {...gold} /></svg>
);
const ClipperIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><rect x="7" y="8" width="10" height="13" rx="2" {...gold} /><path d="M9 8V5h6v3" {...gold} /><line x1="8" y1="3" x2="8" y2="5" {...gold} /><line x1="10.5" y1="3" x2="10.5" y2="5" {...gold} /><line x1="13.5" y1="3" x2="13.5" y2="5" {...gold} /><line x1="16" y1="3" x2="16" y2="5" {...gold} /></svg>
);
const RazorIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><path d="M3 21l6-6" {...gold} /><path d="M9 15l8.5-8.5a2.12 2.12 0 013 3L12 18l-3-3z" {...gold} /><line x1="16" y1="5" x2="19" y2="8" {...gold} /></svg>
);
const SerumIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><path d="M9 8h6v11a2 2 0 01-2 2h-2a2 2 0 01-2-2V8z" {...gold} /><path d="M10 8V5h4v3" {...gold} /><line x1="9" y1="3" x2="15" y2="3" {...gold} /><line x1="9" y1="13" x2="15" y2="13" {...gold} /></svg>
);
const HandIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><path d="M18 11V6a2 2 0 00-4 0v5" {...gold} /><path d="M14 10V4a2 2 0 00-4 0v6" {...gold} /><path d="M10 10.5V6a2 2 0 00-4 0v8" {...gold} /><path d="M18 8a2 2 0 014 0v6a8 8 0 01-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 012.83-2.82L7 15" {...gold} /></svg>
);
const PackageIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" className="icon-draw"><rect x="3" y="8" width="18" height="13" rx="1" {...gold} /><path d="M12 8v13" {...gold} /><path d="M3 12h18" {...gold} /><path d="M12 8c-1.5-3-5-4-6-2s2 3 6 2z" {...gold} /><path d="M12 8c1.5-3 5-4 6-2s-2 3-6 2z" {...gold} /></svg>
);

const services = [
  { icon: <ScissorsIcon />, title: "Haarschnitt", sub: "Klassisch", desc: "Präzise. Sauber. Zeitlos." },
  { icon: <ClipperIcon />, title: "Fade & Modern Cut", sub: "Modern", desc: "Von Low Fade bis High Skin — dein Stil, unsere Hand." },
  { icon: <RazorIcon />, title: "Rasur & Bartstyling", sub: "Klassisch", desc: "Klassische Nassrasur mit heißem Handtuch. Bartkontur, -styling und -pflege auf Maß." },
  { icon: <SerumIcon />, title: "Hautpflege für Männer", sub: "Grooming", desc: "Professionelle Gesichtspflege — kein Spa, sondern gezieltes Grooming für den Mann." },
  { icon: <HandIcon />, title: "Maniküre", sub: "Details", desc: "Die Details machen den Mann. Gepflegte Hände als Teil deines kompletten Auftritts." },
  { icon: <PackageIcon />, title: "Kombi-Pakete", sub: "Komplett", desc: "Haarschnitt + Rasur + Pflege — das komplette Verwöhnerlebnis." },
];

export default function Services() {
  return (
    <section id="leistungen" className="py-28 lg:py-36" style={{ background: "#080808" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="pre-headline mb-6"
        >
          Leistungen
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl mb-16"
          data-testid="services-headline"
        >
          Was wir für <span className="gold-text">dich</span> tun.
        </motion.h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="service-card p-8 lg:p-10"
              data-testid={`service-card-${i}`}
            >
              <div className="mb-6">{s.icon}</div>
              <p className="text-[10px] uppercase mb-2" style={{ letterSpacing: "3px", color: "#8B6914" }}>{s.sub}</p>
              <h3 className="font-display text-xl font-bold mb-3">{s.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "#999999" }}>{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
